export const exportCSV = <T = any>(
  rows: T[],
  filename: string,
  header: string,
) => {
  const processRow = (row: T): string => {
    return (
      Object.values(row as any)
        .join(',')
        .replace(/,$/, '') + '\n'
    );
  };

  let csvFile = '';
  if (!!rows.length) {
    for (let i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
    }
  }

  const blobParts = [header, csvFile];
  const blob = new Blob(blobParts, {
    type: 'text/csv;charset=utf-8;',
  });
  saveBlob(blob, `${filename}.csv`);
};

export const exportExcel = async (
  csvData: unknown[],
  fileName: string,
  columns?: string[],
  isXLS2003 = true,
) => {
  const fileType = isXLS2003
    ? 'application/vnd.ms-excel'
    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  // const fileExtension = isXLS2003 ? '.xls' : '.xlsx';
  const fileExtension = '.xlsx';

  const { utils, write } = await import('xlsx');
  const ws = !!columns
    ? utils.json_to_sheet(csvData, { header: columns })
    : utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };

  const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });

  saveBlob(data, `${fileName}${fileExtension}`);
};

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

export const saveBlob = (blob: Blob, filename: string) => {
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

export const transformDataToCsv = (dataArray: any[]) => {
  // Step 1: Convert data to CSV string
  const headers = Object.keys(dataArray[0]).join(',');
  const rows = dataArray.map(obj => Object.values(obj).join(',')).join('\n');
  const csvContent = `${headers}\n${rows}`;

  // Step 2: Create a Blob for the CSV
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  // Step 3: Append Blob and additional payload to FormData
  const formData = new FormData();
  formData.append('files', blob, 'data.csv'); // This should match the field name used in @UploadedFiles('files')

  return formData;
};
